var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgPlaylistAdd = function SvgPlaylistAdd(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "playlist-add_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#playlist-add_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 8.5a.725.725 0 0 1-.535-.216A.726.726 0 0 1 6 7.75V6.5H4.75a.725.725 0 0 1-.534-.216A.726.726 0 0 1 4 5.75c0-.213.072-.391.216-.535A.726.726 0 0 1 4.75 5H6V3.75c0-.213.072-.39.216-.534A.726.726 0 0 1 6.75 3c.213 0 .391.072.535.216a.726.726 0 0 1 .215.534V5h1.25c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.391-.216.535a.726.726 0 0 1-.534.215H7.5v1.25c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.216Zm12.75-3h-8.007a4.726 4.726 0 0 0-.326-1.5H20a1 1 0 0 1 1 1v12.25c-.067 1.492-1.2 2.75-2.75 2.75a2.75 2.75 0 1 1 1.25-5.2V8.5h-8.877c.32-.448.563-.955.71-1.5H19.5V5.5ZM9 14.8V9.934a4.772 4.772 0 0 0 1.5-1.268v8.584C10.433 18.742 9.3 20 7.75 20A2.75 2.75 0 1 1 9 14.8Z",
    fill: "currentColor"
  }))));
};
export default SvgPlaylistAdd;